import { w as l } from "./es.symbol.description-6025a604.js";
import { b, P as p, D as y, y as d, s as m, _ as w } from "./export-cdcbfb2b.js";
import { a as F } from "./array-slice-79f93c56.js";
var $ = l;
$("iterator");
var s = b, h = p, j = y, C = m, u = F, O = d, f = Function, S = s([].concat), _ = s([].join), e = {}, B = function(c, r, n) {
  if (!C(e, r)) {
    for (var o = [], a = 0; a < r; a++)
      o[a] = "a[" + a + "]";
    e[r] = f("C,a", "return new C(" + _(o, ",") + ")");
  }
  return e[r](c, n);
}, D = O ? f.bind : function(r) {
  var n = h(this), o = n.prototype, a = u(arguments, 1), t = function() {
    var i = S(a, u(arguments));
    return this instanceof t ? B(n, i.length, i) : n.apply(r, i);
  };
  return j(o) && (t.prototype = o), t;
}, N = w, v = D;
N({ target: "Function", proto: !0, forced: Function.bind !== v }, {
  bind: v
});
